import React, { FunctionComponent } from "react";
import { style } from "typestyle";

interface IAlignCenterProps {
  children: JSX.Element;
}
const AlignCenter: FunctionComponent<IAlignCenterProps> = (
  props: IAlignCenterProps,
) => (
  <div
    className={style({
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    })}
  >
    {props.children}
  </div>
);

export default AlignCenter;
